<template>
  <company-report-mobile v-if="useMobileReport" />
  <company-report-desktop v-else-if="useDesktopReport" />
  <div v-else>
    <page-header
      icon="mdi-file-chart-outline"
      :title="$t('routes.report')"
      :subtitle="$t('manage_meal_reports')"
    >
      <template #actions>
        <v-row no-gutters justify="end">
          <v-btn v-if="useLegacyDesktop" text small color="primary" class="mr-2 align-self-center" @click="useNewView">
            {{ $t("report_desktop.new_view") }}
          </v-btn>
          <excel-button @click="setExcel" class="mr-2" />
          <print-button @click="setPrinter" />
        </v-row>
      </template>
    </page-header>
    <!-- Multi Restaurant Report -->
    <company-multi-restaurant-report v-if="isMultiRestaurantCompany" />

    <!-- Default Report -->
    <company-default-report v-else />
  </div>
</template>

<script>
import CompanyDefaultReport from "@/components/company/reports/CompanyDefaultReport.vue";
import CompanyMultiRestaurantReport from "@/components/company/reports/CompanyMultiRestaurantReport.vue";
import CompanyReportMobile from "@/components/company-report/mobile/CompanyReportMobile.vue";
import CompanyReportDesktop from "@/components/company-report/CompanyReportDesktop.vue";
import { LEGACY_UI_VALUE } from "@/components/report/desktop/reportQuery";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  name: "CompanyReportPage",
  mixins: [hasPrinting, hasExcel],
  components: {
    CompanyDefaultReport,
    CompanyMultiRestaurantReport,
    CompanyReportMobile,
    CompanyReportDesktop,
  },
  computed: {
    isMultiRestaurantCompany() {
      return this.$store.state.company?.contract === 4;
    },
    /** ?ui=stari vraća staru stranicu (tabovi) dok se novi izgled ne potvrdi. */
    useLegacyDesktop() {
      return !this.device.isMobile && this.$route.query.ui === LEGACY_UI_VALUE;
    },
    /** Telefon (širina do 600 px): početna sa izborom izveštaja i izveštaji u kartičnom prikazu (sve vrste firmi). */
    useMobileReport() {
      return this.device.isMobile && this.$route.query.ui !== LEGACY_UI_VALUE;
    },
    /** Računar i tablet (širina iznad 600 px): gornja navigacija i zajednička traka filtera. */
    useDesktopReport() {
      return !this.device.isMobile && !this.useLegacyDesktop;
    },
  },
  methods: {
    /** Vraća novi izgled (briše ?ui=stari). */
    useNewView() {
      const query = { ...this.$route.query };
      delete query.ui;
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
